// extracted by mini-css-extract-plugin
module.exports = {"svg":"Ring_svg__2eLvB","spin":"Ring_spin__2USqF","ring":"Ring_ring__26vvj","ball":"Ring_ball__2mGER"};